import OverlayBluredRight from './OverlayBluredRight';

export default OverlayBluredRight;
